import dynamic from 'next/dynamic';
import React from 'react';
import SectionLoader from '../../global/SectionLoader/SectionLoader';

export const DynamicComponentForInPageSearch = dynamic(
  () => import('../../searchLocation/inPageSearch/InPageSearch'),
  {
    ssr: false,
    loading: () => <SectionLoader height={[368, 266, 186]} noMargin />,
  },
);

export const DynamicComponentForLocationRecommendation = dynamic(
  () => import('../../locationRecommendation/LocationRecommendation'),
  {
    ssr: false,
    loading: () => <SectionLoader height={[291, 287, 287]} noMargin />,
  },
);

export const DynamicComponentForEditorsPicks = dynamic(
  () => import('../../editorsPicks/EditorsPicks'),
  {
    ssr: false,
    loading: () => <SectionLoader height={[307, 303, 303]} noMargin />,
  },
);

export const DynamicComponentForHeroVideo = dynamic(
  () => import('../../heroVideo/HeroVideo'),
  {
    ssr: false,
    loading: () => <SectionLoader height={[466, 722, 528]} noMargin />,
  },
);

export const DynamicComponentForNewsGuidesDecors = dynamic(
  () => import('../../newsGuidesDecors/NewsGuidesDecors'),
  {
    ssr: false,
    loading: () => <SectionLoader height={[1405, 1336, 475]} noMargin />,
  },
);

export const DynamicComponentForFeaturedVideos = dynamic(
  () => import('../../featuredVideos/FeaturedVideos'),
  {
    ssr: false,
    loading: () => <SectionLoader height={[385, 464, 160]} noMargin />,
  },
);

export const DynamicComponentForArticleFeedModule = dynamic(
  () => import('../../articleFeed/ArticleFeedModule'),
  {
    ssr: false,
    loading: () => <SectionLoader height={[1052, 1127, 886]} noMargin />,
  },
);
